import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
// import Auth from './auth/reducer';
// import GlobalComponentDemo from './globalComponentDemo/reducer'

import App from './App/reducer';
import Auth from './Auth/reducer';
import Dashboard from './Dashboard/reducer';
import DashboardDokter from './DashboardDokter/reducer';
import DashboardApotek from './DashboardApotek/reducer';
import ModulePasien from './ModulePasien/reducer';
import ModuleLayanan from './ModuleLayanan/reducer';
import ModulePoli from './ModulePoli/reducer';
import ModuleObat from './ModuleObat/reducer';
import ModuleDokter from './ModuleDokter/reducer';
import ModuleReservasi from './ModuleReservasi/reducer';
import ModuleKasir from './ModuleKasir/reducer';
import ModuleUserMedis from './ModuleUserMedis/reducer';
import ModuleRekamMedis from './ModuleRekamMedis/reducer';
import ModuleReport from './ModuleReport/reducer';

export default {
    App,
    Auth,
    Dashboard,
    ModulePasien,
    ModuleLayanan,
    ModulePoli,
    ModuleObat,
    ModuleDokter,
    ModuleReservasi,
    DashboardDokter,
    DashboardApotek,
    ModuleKasir,
    ModuleUserMedis,
    ModuleRekamMedis,
    ModuleReport,
}